module.exports = __webpack_public_path__ + "img/create-account-icon-2.ad6682c1.png";